'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var commentVisibilityLevels = [{ icon: 'users', value: 'public' }, { icon: 'lock', value: 'internal' }];

var getVisibilityLevels = function getVisibilityLevels(tt, accessLevel) {
    accessLevel = accessLevel || commentVisibilityLevels[commentVisibilityLevels.length - 1].value;

    var accessLevelIndex = commentVisibilityLevels.findIndex(function (l) {
        return l.value === accessLevel;
    });

    return commentVisibilityLevels.map(function (l, index) {
        return {
            icon: l.icon,
            value: l.value,
            label: tt('visibility_option_' + l.value + '_label'),
            description: tt('visibility_option_' + l.value + '_description'),
            disabled: index > accessLevelIndex
        };
    });
};

exports.getVisibilityLevels = getVisibilityLevels;